import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltReactionsPanelItemEmojiWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reactions-panel-item-emoji-wireframe", __assign({}, transformedProps), children));
};
export default VeltReactionsPanelItemEmojiWireframe;
